import { useEffect } from "react";
import { enableCsrf } from "../csrf";

/**
 * CSRF Protection id injected by WAF. This introduces the protection for local development.
 */
const useCsrfProtection = (): void => {
  useEffect(() => {
    if (import.meta.env.DEV) {
      enableCsrf();
    }
  }, []);
};

export default useCsrfProtection;
